import React, { useState } from 'react';
import {
  Box,
  Button
} from '@material-ui/core';

import CustomerDetails from 'components/Customers/CustomerDetails';
import CustomersTable from 'components/Customers/CustomersTable';

import { admin, standard } from 'variables/userAccountTypes';

const CustomerListResults = (props) => {
  
  const [open, setOpen] = useState(false);
  const [update, setUpdate] = useState(false);
  const [updateInfo, setUpdateInfo] = useState({});

  const addCustomer = () => {
    setOpen(true);
    setUpdate(false);
    setUpdateInfo({});
  };

  const updateCustomer = () => {
    setOpen(true);
    setUpdate(true);
  };

  const cancelAddUpdate = () => {
    setOpen(false);
    setUpdate(false);
    setUpdateInfo({});
  };

  const createCustomerDisplayId = () => {
    let length;
    props.activeUserType === standard ?
      length = props.idGen.find(idGen => idGen.info.user === props.user.adminId).body.customer
    : length = props.idGen.find(idGen => idGen.info.user === props.activeUserId).body.customer

    let customerNum;
    length < 100 ?
      customerNum = new Array(3 + 1 - (length + '').length).join('0') + length
    : customerNum = length
    return ("C-" + customerNum);
  };

  return (
    <Box>
      { !(open || props.activeUserType === admin) ?
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <Button
          color="primary"
          variant="contained"
          onClick={addCustomer}
        >
          Add customer
        </Button>
      </Box> : null }
      <Box sx={{ mt: 3 }}>
        { open ?
          ( update ?
            <CustomerDetails
              update={update}
              cancelAddUpdate={cancelAddUpdate}
              customerInfo={updateInfo}
            /> :
            <CustomerDetails
              update={update}
              activeUserId={props.activeUserId}
              activeUserType={props.activeUserType}
              user={props.user}
              cancelAddUpdate={cancelAddUpdate}
              customerInfo={{
                displayId: createCustomerDisplayId(),
                name: "",
                phone: "",
                addressLine: "Sharjah",
                city: "sharjah",
                country: "UAE",
                trn: ""
              }}
            />
          ) :
          <CustomersTable
            activeUserType={props.activeUserType}
            salesOrders={props.salesOrders}
            user={props.user}
            customers={props.customers}
            updateCustomer={updateCustomer}
            setUpdateInfo={setUpdateInfo}
          />
        }
      </Box>
    </Box>
  )
};

export default CustomerListResults;
